(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/models/xperten.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/models/xperten.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen = svs.matchen || {};
  svs.matchen.models = svs.matchen.models || {};

  svs.matchen.models.Xperten = Backbone.Model.extend({
    defaults: function() {
      return {
        active: false,
        systemSize: '2',
        trySystemSize: '2',
        systemSizes: JSON.parse(JSON.stringify([[2, 3, 4], [5, 6, 8], [10, 15, 20]])),
        results: JSON.parse(JSON.stringify([]))
      };
    },

    url: function() {
      var drawNumber = this.get('drawNumber');

      if (!drawNumber) {
        this.logger.warn(
          'Invalid drawNumber when trying to fetch Xperten.',
          drawNumber
        );
      }

      return (
        svs.core.jupiter.url() +
        '/wager/1/matchen/pix?drawNumber=' +
        drawNumber +
        '&size=' +
        this.get('systemSize') +
        '&flavour=SafeBombenMatchen'
      );
    },

    initialize: function() {
      this.logger = new svs.core.log.Logger('svs.matchen.models.Xperten');
      this.preserve = true;
      this.preserveBindings = true;

      this.set('reductions', new svs.matchen.collections.Reductions());

      this.listenTo(
        this.getReductions(),
        'change:selected',
        this.onReductionSelected
      );
    },

    setReductions: function(reductions, options) {
      this.get('reductions').set(reductions, options);
    },

    fetch: function(options) {
      var self = this;
      var origSuccess;
      var origError;

      options = _.defaults({}, options, {
        success: function() {},
        error: function() {}
      });

      options.type = 'POST';

      var reductionsString = this.getReductions().getSelectedReductionsString();
      if (reductionsString) {
        options.data = {
          events: [
            {
              eventNumber: 1,
              reducing: this.getReductions().getSelectedReductionsString(),
              outcomes: [
              ]
            }
          ]
        };
      }

      origSuccess = options.success;
      origError = options.error;

      this.setSystemSize(this.get('trySystemSize'));

      return this.sync(
        'read',
        this,
        _.extend(options, {
          success: function(response) {
            self.set(_.extend({}, self.parse(response), { active: true }));
            origSuccess(self, response, options);
            self.trigger('sync', self, response, options);
          },

          error: function(xhr) {
            self.setSystemSize(self.previous('systemSize')); 
            origError(self, xhr, options);
            self.trigger('error', self, xhr, options);
          }
        })
      );
    },

    parse: function(response) {
      if (!response) {
        return this.logger.info('Invalid response.', response);
      }

      if (response && response.error) {
        return this.logger.info('Error when fetching Xperten.', response.error);
      }

      var wager = new svs.matchen.models.PixWager().get('wager');
      Object.assign(wager, response);
      delete wager.pix;
      wager.bets[0].drawNum = this.get('drawNumber');
      var eventResults = this.hasResponseEventResults(response);
      wager.bets[0].expertenBoardData.eventResults[0] = eventResults;

      return {
        results: eventResults,
        wager: wager
      };
    },

    onReductionSelected: function(reduction, value, options) {
      if (!options.reverted) {
        this.fetch({
          error: function() {
            reduction.set('selected', !value, { reverted: true }); 
          }
        });
      }
    },

    hasResponseEventResults: function(response) {
      if (svs.utils.ns.isNamespace('pix.events.0.outcomes.0', response)) {
        var outcomes = response.pix.events[0].outcomes;
        var outcomesArray = outcomes.map(function(outcome) {
          var outcomeValuesArray = Object.values(outcome);
          return outcomeValuesArray.map(String);
        });

        return outcomesArray;
      }

      if (svs.utils.ns.isNamespace('wager.bets.0.expertenBoardData.eventResults.0', response)) {
        return response.wager.bets[0].expertenBoardData.eventResults[0];
      }
    },

    getResults: function() {
      return this.get('results');
    },

    isActive: function() {
      return this.get('active');
    },

    setActive: function(value, options) {
      this.set('active', value, options);
    },

    getSystemSize: function() {
      return this.get('systemSize');
    },

    setSystemSize: function(size, options) {
      this.set('systemSize', size, options);
    },

    resetModel: function(options) {
      this.getReductions().setDefaultReductions(options);
      this.set(_.result(this, 'defaults'));
    },

    toJSON: function() {
      return JSON.parse(JSON.stringify(this.attributes));
    },

    clone: function() {
      return new this.constructor(this.toJSON());
    },

    getReductions: function() {
      return this.get('reductions');
    }
  });
})(Backbone, _, svs);


 })(window);